import type { ReactNode } from 'react';

export function PageTitle(props: { children: ReactNode; className?: string }) {
    return <h1 className={props.className || ''}>{props.children}</h1>;
}
